import React from "react";

const OrderDetails = () => {
  return (
    <div className="w-[85%] mx-auto mt-[4rem] shadow-2xl p-6 mb-[2rem]">
      <h1 className="text-4xl font-Roboto ">Order details</h1>
      {/* Items */}
      <div>
        <h1 className="font-bold my-[2rem] text-2xl ">Items</h1>
        <div className="flex gap-2">
          {Array(6)
            .fill()
            .map((id) => {
              return (
                <div className="w-[10rem] h-[auto] bg-[#358280] font-Roboto rounded-xl text-white p-1">
                  <h1>Hello</h1>
                  <h1>Quantity:2</h1>
                </div>
              );
            })}
        </div>
      </div>
      {/* Status */}
      <div className="mt-[4rem]">
        <h1 className="font-bold my-[2rem] text-2xl ">Status</h1>
        <div className="flex gap-2">
          {Array(5)
            .fill()
            .map((id) => {
              return (
                <div className="w-[10rem] h-[auto]  font-Roboto rounded-xl   p-1">
                  <label className="inline-flex items-center ">
                    <input
                      type="checkbox"
                      className="w-6 h-6 rounded-xl border-0 focus:ring-0 focus:bg-green-200  text-green-600"
                    />
                  </label>
                  <h1 className="font-Roboto text-sm font-semibold">
                    Your Food is cooking
                  </h1>
                </div>
              );
            })}
        </div>
      </div>

      {/* Personal details */}
      <div className="my-[4rem] font-Poppins">
        <h1 className="font-bold my-[2rem] text-2xl ">Presonal Detais</h1>
        <div className="pr-[6rem]">
          <div className="flex justify-between">
            <div>
              <h1>Full name</h1>
              <h1>Binod</h1>
            </div>
            <div>
              <h1>Date</h1>
              <h1>Blabla</h1>
            </div>
            <div>
              <h1>Address</h1>
              <h1>Blabla</h1>
            </div>
          </div>
          <div className="flex justify-between pt-[4rem]">
            <div>
              <h1 className="text-[#707070]">Full name</h1>
              <h1>Binod</h1>
            </div>
            <div>
              <h1>Date</h1>
              <h1>Blabla</h1>
            </div>
            <div>
              <h1>Address</h1>
              <h1>Blabla</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
